export default {
    histoWf: [],
};